export default {
    histoWf: [],
};